module.exports = __webpack_public_path__ + "static/media/video.14079936.svg";